<template>
  <div>
    <input
      class="modal-state"
      id="builder-require-auth-modal"
      type="checkbox"
      @input="$emit('input', !!$event.target.checked)"
      :checked="value"
    />
    <div class="modal">
      <label
        class="modal__bg"
        for="builder-require-auth-modal"
      ></label>
      <div class="modal__inner">
        <label
          class="modal__close"
          for="builder-require-auth-modal"
        ></label>
        <div
          class="h-full w-full flex flex-col items-center justify-between"
        >
          <div class="mt-2 text-lg text-gray-900 font-bold">
            Sign in to continue
          </div>
          <div>
            <div class="text-gray-600">
              Create a
              <span class="font-semibold"
                >free account</span
              >
              or
              <span class="font-semibold">sign in</span> to
              preview your application.
            </div>
            <div class="mt-2 text-gray-600">
              The project state is saved on your local
              storage, but might be a good idea to
              <el-link type="primary" @click="save()"
                >download the project file</el-link
              >, just in case.
            </div>
          </div>

          <router-link
            class="w-full"
            :to="`/auth/sign-in?referrer=/`"
          >
            <el-button
              native-type="button"
              class="mb-2 w-full"
              type="primary"
              >Sign in</el-button
            ></router-link
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-builder-require-auth-modal',
  props: ['value'],
  methods: {
    save() {
      this.$store.dispatch('builder/downloadData');
    },
  },
};
</script>

<style scoped>
.modal {
  opacity: 0;
  visibility: hidden;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  text-align: left;
  background: rgba(0, 0, 0, 0.9);
  z-index: 2;
  transition: opacity 0.25s ease;
}

.modal__bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  cursor: pointer;
}

.modal-state {
  display: none;
}

.modal-state:checked + .modal {
  opacity: 1;
  visibility: visible;
}

.modal-state:checked + .modal .modal__inner {
  top: 0;
}

.modal__inner {
  transition: top 0.25s ease;
  position: absolute;
  top: -20%;
  right: 0;
  bottom: 0;
  left: 0;
  width: 40%;
  margin: auto;
  overflow: auto;
  background: #fff;
  border-radius: 5px;
  padding: 1em 2em;
  height: 240px;
}

.modal__close {
  position: absolute;
  right: 1em;
  top: 1em;
  width: 1.1em;
  height: 1.1em;
  cursor: pointer;
}

.modal__close:after,
.modal__close:before {
  content: '';
  position: absolute;
  width: 2px;
  height: 1.5em;
  background: #ccc;
  display: block;
  transform: rotate(45deg);
  left: 50%;
  margin: -3px 0 0 -1px;
  top: 0;
}

.modal__close:hover:after,
.modal__close:hover:before {
  background: #aaa;
}

.modal__close:before {
  transform: rotate(-45deg);
}

@media screen and (max-width: 992px) {
  .modal__inner {
    width: 50%;
    height: 240px;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 768px) {
  .modal__inner {
    width: 90%;
    height: 240px;
    box-sizing: border-box;
  }
}
</style>
